export default __webpack_public_path__ + "static/hero-viterbi-1f8d26b5433f76da3c8fa2986ddc3afd.svg";